module.exports = {"content":{},"productInfo":{"code":"{71C13FA7-95EE-4349-A503-F1C8E3F22092}","name":"ヒンディー語　初中級","serialHead":"BSWTJ","courseResourceIDs":[{"levelNo":1,"resourceID":"130910d95da8813091bf2ff6d1c9ccfe1cd5e4ea"},{"levelNo":2,"resourceID":"6f87a18e1c013d2700a1314e31cf2016ca27c164"},{"levelNo":3,"resourceID":"ce4c6caa1eb34049be2dfa1fc9b4ca54a1452557"}],"language":"hi-IN","challengeCount":21581},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1